/* American Threads Co - "Preview your shirt" for one name on the chest, in the
   font and ink colour the shopper picks (SP009 Christmas tree Hawaiian shirt).

   Reads window.ATC_CUSTOM_FIELDS.preview.chest (product metafield atc.custom_fields):
     { "field": "Name", "fontField": "Font", "colorField": "Ink Color",
       "designOption": "Design", "w": 1254, "crop": [x, y, w, h], "scale": 1.2,
       "defaultFont": "Font 1", "defaultColor": "Cream",
       "fonts":  { "Font 1": "<ttf url>", ... },
       "colors": { "Cream": "#efe6d2", ... },
       "designs": { "Design 1": { "bg": "<front photo, pattern cleared round the chest>",
                                  "c": [cx, cy], "maxw": 150, "maxh": 38,
                                  "motifs": "<png of pattern motifs for the cleared area>",
                                  "mxy": [x, y], "boxes": [[x, y, w, h], ...] } } }
   The name is fitted inside maxw x maxh (photo pixels) around c, then the
   photo is laid over the letters at low opacity so the weave shows through,
   like the printed ink. The background has the pattern cleared round the
   chest; every motif in "motifs" that stays clear of the letters (gap px) is
   put back, so the pattern hugs the name whatever its length (Andi 19/10).
   Loads only for products tagged chest-preview, and leaves
   atc-name-preview.js alone.
*/
(function () {
  var imgs = {}, faces = {}, pop = null, lastBtn = null;

  function cfg() {
    var c = window.ATC_CUSTOM_FIELDS, p = c && c.preview;
    return p && p.chest && p.chest.designs ? p.chest : null;
  }

  function loadImg(url) {
    if (!url) return Promise.resolve(null);
    if (imgs[url]) return imgs[url];
    imgs[url] = new Promise(function (res) {
      var img = new Image();
      img.onload = function () { res(img); };
      img.onerror = function () { res(null); };
      img.src = url;
    });
    return imgs[url];
  }

  function family(key) { return 'ATC Chest ' + String(key).replace(/[^A-Za-z0-9]/g, ''); }

  function loadFont(c, key) {
    var url = c.fonts[key];
    if (!url || !window.FontFace) return Promise.resolve();
    if (faces[key]) return faces[key];
    faces[key] = new FontFace(family(key), 'url(' + url + ')').load().then(function (f) {
      document.fonts.add(f);
    }).catch(function () {});
    return faces[key];
  }

  function addStyle() {
    if (document.getElementById('atc-cp-style')) return;
    var s = document.createElement('style');
    s.id = 'atc-cp-style';
    s.textContent = [
      '.atc-cp-btn{width:100%;margin-top:12px;padding:13px 16px;border-radius:8px;border:1px solid currentColor;background:transparent;color:inherit;font:inherit;font-size:14px;font-weight:600;letter-spacing:.02em;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;}',
      '.atc-cp-btn:hover{background:rgba(255,255,255,.08);}',
      '.atc-cp-btn svg{width:18px;height:18px;flex:0 0 auto;}',
      '.atc-cp-msg{font-size:12px;margin:6px 0 0;color:#ff8a8a;}',
      '.atc-cp-msg[hidden]{display:none;}',
      '.atc-cp{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.72);}',
      '.atc-cp[hidden]{display:none;}',
      '.atc-cp__box{position:relative;width:100%;max-width:440px;max-height:94vh;overflow:auto;border-radius:16px;background:#fff;color:#2b1a12;padding:16px 16px 18px;box-shadow:0 24px 60px rgba(0,0,0,.6);}',
      '.atc-cp__x{position:absolute;top:10px;right:10px;width:34px;height:34px;border:0;border-radius:50%;background:rgba(0,0,0,.06);color:#2b1a12;font-size:20px;line-height:1;cursor:pointer;}',
      '.atc-cp__title{margin:2px 40px 2px 2px;font-size:17px;font-weight:700;}',
      '.atc-cp__sub{margin:0 2px 10px;font-size:13px;opacity:.7;}',
      '.atc-cp__canvas{display:block;width:100%;height:auto;border-radius:12px;background:#efe6dc;}',
      '.atc-cp__note{margin:10px 2px 12px;font-size:12px;line-height:1.45;opacity:.65;}',
      '.atc-cp__row{display:flex;gap:8px;}',
      '.atc-cp__row button{flex:1 1 0;padding:12px;border-radius:8px;font:inherit;font-size:14px;font-weight:600;cursor:pointer;}',
      '.atc-cp__edit{border:1px solid #2b1a12;background:#fff;color:#2b1a12;}',
      '.atc-cp__ok{border:1px solid #c4202e;background:#c4202e;color:#fff;}'
    ].join('');
    document.head.appendChild(s);
  }

  function optionValue(name) {
    var opt = String(name || '').toLowerCase();
    var sets = document.querySelectorAll('fieldset.variant-option, fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (!lg || lg.textContent.toLowerCase().indexOf(opt) === -1) continue;
      var r = sets[i].querySelector('input[type="radio"]:checked');
      if (r) return r.value;
    }
    var sels = document.querySelectorAll('select');
    for (var j = 0; j < sels.length; j++) {
      var nm = (sels[j].name || '') + ' ' + (sels[j].getAttribute('aria-label') || '');
      if (nm.toLowerCase().indexOf(opt) !== -1 && nm.indexOf('properties[') === -1) return sels[j].value;
    }
    return '';
  }

  function pick(map, value) {
    if (map[value]) return map[value];
    var keys = Object.keys(map), v = String(value).toLowerCase();
    for (var i = 0; i < keys.length; i++) {
      if (v && v.indexOf(keys[i].toLowerCase()) !== -1) return map[keys[i]];
    }
    return map[keys[0]];
  }

  function field(name) {
    return document.querySelector('[data-atc-ct] [name="properties[' + name + ']"]');
  }

  /* put back each pattern motif whose box (grown by gap) touches no letter */
  function putMotifs(ctx, view, d, mot, fam, name, k, tx, ty, gap) {
    var x0 = d.mxy[0], y0 = d.mxy[1], mw = mot.width, mh = mot.height;
    var n = document.createElement('canvas');
    n.width = mw; n.height = mh;
    var nc = n.getContext('2d');
    nc.translate(d.c[0] - x0, d.c[1] - y0);
    nc.scale(k, k);
    nc.font = "100px '" + fam + "', cursive";
    nc.fillText(name, tx, ty);
    var px = nc.getImageData(0, 0, mw, mh).data;
    ctx.setTransform.apply(ctx, view);
    (d.boxes || []).forEach(function (b) {
      var bx = b[0] - x0, by = b[1] - y0;
      var xa = Math.max(0, bx - gap), xb = Math.min(mw, bx + b[2] + gap);
      var ya = Math.max(0, by - gap), yb = Math.min(mh, by + b[3] + gap);
      for (var y = ya; y < yb; y++) {
        for (var x = xa; x < xb; x++) {
          if (px[(y * mw + x) * 4 + 3] > 20) return;
        }
      }
      ctx.drawImage(mot, bx, by, b[2], b[3], b[0], b[1], b[2], b[3]);
    });
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }

  function render(canvas, c, d, name, fontKey, color, bg, mot) {
    var cr = c.crop || [0, 0, c.w, c.w], sc = c.scale || 1.2;
    var W = Math.round(cr[2] * sc), H = Math.round(cr[3] * sc);
    canvas.width = W; canvas.height = H;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#efe6dc';
    ctx.fillRect(0, 0, W, H);
    if (!bg) return;
    var view = [sc, 0, 0, sc, -cr[0] * sc, -cr[1] * sc];
    ctx.setTransform.apply(ctx, view);
    ctx.drawImage(bg, 0, 0, c.w, c.w);
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    var t = document.createElement('canvas');
    t.width = W; t.height = H;
    var tc = t.getContext('2d');
    var fam = family(fontKey), ref = 100;
    tc.font = ref + "px '" + fam + "', cursive";
    var m = tc.measureText(name);
    var w = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
    var h = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
    var k = Math.min(d.maxw / w, d.maxh / h);
    var tx = -w / 2 + m.actualBoundingBoxLeft, ty = (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2;
    if (mot) putMotifs(ctx, view, d, mot, fam, name, k, tx, ty, c.gap || 6);
    tc.setTransform.apply(tc, view);
    tc.translate(d.c[0], d.c[1]);
    tc.scale(k, k);
    if ('filter' in tc) tc.filter = 'blur(' + (0.45 / (k * sc)).toFixed(2) + 'px)';
    tc.fillStyle = color;
    tc.globalAlpha = 0.96;
    tc.font = ref + "px '" + fam + "', cursive";
    tc.fillText(name, tx, ty);
    /* weave of the fabric through the ink */
    tc.setTransform.apply(tc, view);
    if ('filter' in tc) tc.filter = 'none';
    tc.globalAlpha = 0.16;
    tc.globalCompositeOperation = 'source-atop';
    tc.drawImage(bg, 0, 0, c.w, c.w);
    ctx.drawImage(t, 0, 0);
  }

  function show(canvas, c, dv, name, fontKey, colorKey) {
    var d = pick(c.designs, dv), color = pick(c.colors, colorKey);
    render(canvas, c, d, name, fontKey, color, null, null);
    return Promise.all([loadImg(d.bg), loadFont(c, fontKey), loadImg(d.motifs)]).then(function (r) {
      render(canvas, c, d, name, fontKey, color, r[0], r[2]);
    });
  }

  function popup() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'atc-cp';
    pop.hidden = true;
    pop.innerHTML =
      '<div class="atc-cp__box" role="dialog" aria-modal="true" aria-labelledby="atc-cp-title">' +
      '<button type="button" class="atc-cp__x" aria-label="Close">&times;</button>' +
      '<p class="atc-cp__title" id="atc-cp-title">Your personalization preview</p>' +
      '<p class="atc-cp__sub" data-atc-cp-sub></p>' +
      '<canvas class="atc-cp__canvas" width="960" height="960"></canvas>' +
      '<p class="atc-cp__note" data-atc-cp-note></p>' +
      '<div class="atc-cp__row"><button type="button" class="atc-cp__edit">Edit name</button>' +
      '<button type="button" class="atc-cp__ok">Looks good</button></div>' +
      '</div>';
    pop.querySelector('.atc-cp__x').addEventListener('click', close);
    pop.querySelector('.atc-cp__ok').addEventListener('click', close);
    pop.querySelector('.atc-cp__edit').addEventListener('click', function () {
      close();
      var c = cfg(), f = c && field(c.field || 'Name');
      if (f) { f.focus(); f.select(); }
    });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.body.appendChild(pop);
    return pop;
  }

  function close() {
    if (pop) pop.hidden = true;
    if (lastBtn) lastBtn.focus();
  }

  function open(btn) {
    var c = cfg(), f = field(c.field || 'Name');
    var msg = btn.parentNode.querySelector('.atc-cp-msg');
    var name = f ? String(f.value || '').trim() : '';
    if (!name) {
      if (msg) msg.hidden = false;
      if (f) f.focus();
      return;
    }
    if (msg) msg.hidden = true;
    lastBtn = btn;
    var ff = field(c.fontField || 'Font'), cf = field(c.colorField || 'Ink Color');
    var fk = (ff && ff.value) || c.defaultFont, ck = (cf && cf.value) || c.defaultColor;
    var dv = optionValue(c.designOption || 'Design');
    var p = popup();
    p.querySelector('[data-atc-cp-note]').textContent = c.note ||
      'Preview only. Your name is printed exactly as typed on the left chest.';
    p.querySelector('[data-atc-cp-sub]').textContent = [dv, fk, ck].filter(Boolean).join(' · ') + ' · "' + name + '"';
    p.hidden = false;
    p.querySelector('.atc-cp__ok').focus();
    show(p.querySelector('canvas'), c, dv, name, fk, ck);
  }

  function inject() {
    var c = cfg();
    if (!c) return;
    var f = field(c.field || 'Name');
    if (!f) return;
    var box = f.closest('.atc-ct__body') || f.parentNode;
    if (box.querySelector('.atc-cp-btn')) return;
    addStyle();
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'atc-cp-btn';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/><circle cx="12" cy="12" r="3"/></svg><span></span>';
    b.querySelector('span').textContent = c.button || 'Preview your shirt';
    b.addEventListener('click', function () { open(b); });
    var m = document.createElement('p');
    m.className = 'atc-cp-msg';
    m.hidden = true;
    m.textContent = 'Type a name first, then tap preview.';
    box.appendChild(b);
    box.appendChild(m);
    f.addEventListener('input', function () { m.hidden = true; });
    var ff = field(c.fontField || 'Font');
    if (ff) ff.addEventListener('change', function () { if (ff.value) loadFont(c, ff.value); });
    loadFont(c, c.defaultFont);
  }

  function start() {
    inject();
    new MutationObserver(function () { inject(); }).observe(document.body, { childList: true, subtree: true });
  }

  /* for option images and tests: ATC_CP_RENDER(canvas, name, design, font, color) */
  window.ATC_CP_RENDER = function (canvas, name, design, font, color) {
    var c = cfg();
    return show(canvas, c, design, name, font || c.defaultFont, color || c.defaultColor);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
